<template>
  <div class="video-positioner">
    <div class="video-container" v-if="showVideo">
      <FontIcon
        class="close-icon"
        data-cy="close-video-player-button"
        @click.native="killVideo"
        >close</FontIcon
      >
      <div id="player" class="plyr__video-embed">
        <iframe
          :src="videoUrl"
          class="video-iframe"
          allowfullscreen
          allowtransparency
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { EventBus, EventBusEvents } from '@/helpers/event-bus';
import FontIcon from '@/components/FontIcon.vue';
import Plyr from 'plyr';

@Component({
  components: {
    FontIcon
  }
})
export default class VideoPlayer extends Vue {
  private videoUrl: string | null = null;

  private autoplay: boolean = true;

  private player: Plyr | null = null;

  private get showVideo(): boolean {
    return this.videoUrl !== null;
  }

  private normalizeVideoUrl(url: string): string {
    const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
    if (shortMatch) {
      return `https://www.youtube.com/embed/${shortMatch[1]}`;
    }
    const watchMatch = url.match(/youtube\.com\/watch\?.*v=([^&]+)/);
    if (watchMatch) {
      return `https://www.youtube.com/embed/${watchMatch[1]}`;
    }
    return url;
  }

  private onVideo(videoUrl: string, autoplay: boolean = true) {
    this.autoplay = autoplay;
    this.killVideo();
    // wait for template to render with no iframe
    this.$nextTick(() => {
      this.videoUrl = this.normalizeVideoUrl(videoUrl);
      // wait template to render with new iframe
      this.$nextTick(this.launchVideo);
    });
  }

  private launchVideo() {
    this.player = new Plyr('#player', {});
    this.player.on('ready', () => {
      if (this.autoplay) {
        this.player!.play();
      }
    });
  }

  private killVideo() {
    if (this.player) {
      this.player.destroy();
    }
    this.videoUrl = null;
  }

  private created() {
    EventBus.$on(EventBusEvents.playVideo, this.onVideo);
    EventBus.$on(EventBusEvents.killVideo, this.killVideo);
  }

  private beforeDestroy() {
    EventBus.$off(EventBusEvents.playVideo, this.onVideo);
    EventBus.$off(EventBusEvents.killVideo, this.killVideo);
  }
}
</script>
<style lang="stylus">
@import url('https://cdn.plyr.io/3.6.2/plyr.css');

#app {
  .video-positioner {
    position: fixed;
    width: 0px;
    height: 0px;
    overflow: visible;
    top: 50%;
    left: 50%;
    z-index: 203;

    .video-container{
      position: relative;
      left: -360px;
      top: -200px;
      width: 720px;
      height: 400px;
      text-align right

      #player {
        border: 1px solid black
      }

      .close-icon {
        cursor: pointer;
      }
    }

  }
}
</style>
